import script from "./ModalEditarItems.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditarItems.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditarItems.vue?vue&type=style&index=0&id=6061e5fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6061e5fc"]])

export default __exports__